import React, { useRef, useState, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface CustomSelectDropdownProps {
  label: string;
  value: string | null;
  onChange: (val: string) => void;
  options: string[];
  error: string;
}

const DropDownInput: React.FC<CustomSelectDropdownProps> = ({
  label,
  value,
  onChange,
  options,
  error,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="become-volunteer__input"
      style={{ position: "relative" }}
      ref={dropdownRef}
    >
      <div
        className={`custom-select-style ${error ? "error-border" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        tabIndex={0}
      >
        {value ?? label}
        <span className="arrow">
          <KeyboardArrowDownIcon fontSize="small" />
        </span>
      </div>

      {open && (
        <div className="custom-dropdown-options">
          {options.map((opt, index) =>
            index === 0 ? (
              <div className="radio-option disabled-option" key={opt}>
                {opt}
              </div>
            ) : (
              <label className="radio-option" key={opt}>
                <input
                  type="radio"
                  name={label}
                  value={opt}
                  checked={value === opt}
                  onChange={(e) => {
                    onChange(e.target.value);
                    setOpen(false);
                  }}
                />
                {opt}
              </label>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default DropDownInput;
